// extracted by mini-css-extract-plugin
export default {"Line":"BankingIngestionLine_Line__PTcUr","ReviewLink":"BankingIngestionLine_ReviewLink__bPlqc","ReviewIcon":"BankingIngestionLine_ReviewIcon__zClW9"};